(ns common.schema.entities.workspace.kyc.templates.innovestor.legal-entity-cofund-angel-individual
  (:require
   [common.schema.entities.workspace.kyc.templates.innovestor.company-config :as company-config]
   [common.schema.entities.workspace.kyc.templates.capman.pep :as pep]
   [common.schema.entities.workspace.kyc.templates.capman.ubo :as ubo]
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]))

(def schema
  {:kyc-template/template-name
   "Co-Investment Fund Angel - Individual"

   :kyc-template/kyc-form-preface
   company-config/form-preface-text

   :kyc-template/svg-logo
   company-config/svg-logo

   :kyc-template/png-logo
   company-config/png-logo

   :kyc-template/help-email-address
   company-config/contact-email

   :kyc-template/kyc-form-title
   {:translations {:en "Know Your Customer (KYC) form"
                   :fi "Asiakastietokysely"}}

   :kyc.natural-person/basic-information
   {:ord          1.0
    :translations {:en "Basic information"
                   :fi "Perustiedot"}
    :pdf-columns  2
    :questions    (questions-registry/resolve-questions
                   [[:kyc-person/first-name]
                    [:kyc-person/last-name]
                    [:kyc-person/nationality]
                    [:kyc-person/dob]
                    [:kyc-person/pob]
                    [:kyc-person/pin]
                    [:kyc-person/address]
                    [:kyc-person/zip-code]
                    [:kyc-person/city]
                    [:kyc-person/country]
                    [:kyc-person/email]
                    [:kyc-person/phone]
                    [:kyc-person/source-of-wealth]
                    [:kyc-person/ubo-edn {:data/template ubo/schema}]
                    [:kyc-person/tax-country]
                    [:kyc-person/confirm-marketing-consent]])}

   :kyc.natural-person/pep-information
   {:ord
    2.0
    :translations
    {:en "Politically exposed person (PEP)"
     :fi "Poliittinen vaikutusvalta (PEP)"}
    :info
    {:en
     (str
      "<p>A person is considered a PEP, who is in a prominent public function or an immediate family "
      "member or a close associate of such a person either in Finland or another country?</p>")

     :fi
     (str
      "<p>Henkilö on poliittisesti vaikutusvaltainen, jos hän tai hänen lähipiiriinsä kuuluva henkilö "
      "toimii tai on toiminut merkittävässä julkisessa virassa Suomessa tai toisessa valtiossa.</p>")}
    :more-info
    {:link-text {:en "More information"
                 :fi "Lisätietoa täällä"}
     :info-header {:en "Politically exposed person (PEP)"
                   :fi "Poliittinen vaikutusvalta (PEP)"}
     :info-content
     {:en
      (str
       "<p>Politically Exposed Person <strong>(“PEP”)</strong> refers to a person who is or "
       "during <strong>the last 12 months</strong> "
       "has been in a prominent public function, a close associate or an immediate family member "
       "of such a person either in Finland or another country:</p>"
       "<p><strong>A prominent public function is acting as:</strong>"
       "<ul><li>Head of State, Head of Government, minister, deputy or assistant minister</li>"
       "<li>Member of Parliament</li>"
       "<li>member of supreme court, member of constitutional court or member of some "
       "corresponding judicial body whose decisions are not generally subject to further appeal</li>"
       "<li>member of court of auditors or of the highest decision-making body of an "
       "authority auditing the management of Government funds and corresponding to the "
       "State Audit Office</li>"
       "<li>member of the Board of a central bank</li>"
       "<li>ambassador or chargé d’affaires</li>"
       "<li>high-ranking officer (minimum rank of general) in the armed forces</li>"
       "<li>member of the administrative, management or supervisory body of a "
       "state-owned company</li>"
       "<li>Member of the EU Parliament</li>"
       "<li>commissioner</li>"
       "<li>Member of the EU Court of Justice</li>"
       "<li>Member of the EU Court of Auditors</li></ul></p>"
       "<p><strong>The associates of politically exposed persons are:</strong>"
       "<ul><li>Any natural person who is known to have joint beneficial ownership of a "
       "corporation, entrepreneur or legal arrangement, or any other close business relations, "
       "with a politically exposed person</li>"
       "<li>Any natural person who has sole beneficial ownership of a corporation, "
       "entrepreneur or legal arrangement which is known to have been set up for the benefit "
       "of a politically exposed person</li></ul></p>"
       "<p><strong>The immediate family members of politically exposed persons are:</strong>"
       "<ul><li>The spouse or any partner considered equivalent to a spouse by national law;</li>"
       "<li>The children and their spouses or partners referred to above; and</li>"
       "<li>The parents.</li></ul></p>")
      :fi
      (str
       "Poliittisesti vaikutusvaltainen henkilö <strong>(“PEP”)</strong> toimii tai on toiminut "
       "merkittävässä julkisessa virassa, kuuluu tai on kuulunut sellaisen henkilön lähipiiriin "
       "tai on tai on ollut sellaisen henkilön perheenjäsen tai lähipiiriin kuuluva, Suomessa "
       "tai toisessa valtiossa <strong>viimeisen 12 kuukauden aikana</strong>:</p>"
       "<p><strong>Merkittävänä poliittisena virkana pidetään seuraavia virkoja:</strong>"
       "<ul><li>Valtion- tai hallituksen päämies, ministeri, vara-tai apulaisministeri</li>"
       "<li>Parlamentin jäsen</li>"
       "<li>Korkeimman oikeuden, perustuslakituomioistuimen tai muun vastaavan oikeuselimen jäsen</li>"
       "<li>Keskuspankin johtokunnan jäsen</li>"
       "<li>Suurlähettiläs</li>"
       "<li>Puolustusvoimien kenraalikuntaan kuuluva upseeri</li>"
       "<li>Valtionyritysten hallinto-, johto- ja valvontaelimen jäsen</li>"
       "<li>EU-parlamentin jäsen</li>"
       "<li>Komission jäsen</li>"
       "<li>EU-tuomioistuimen jäsen</li>"
       "<li>EU:n tilintarkastustuomioistuimen jäsen</li></ul></p>"
       "<p><strong>Poliittisesti vaikutusvaltaisen henkilön lähipiiriin kuuluvaksi katsotaan:</strong>"
       "<ul><li>Luonnollinen henkilö, joka toimii poliittisesti vaikutusvaltaisen henkilön "
       "yhtiökumppanina</li>"
       "<li>Luonnollinen henkilö, jonka omistaman yhtiön tosiasiallisena edunsaajana on "
       "poliittisesti vaikutusvaltainen henkilö.</li></ul></p>"
       "<p><strong>Poliittisesti vaikutusvaltaisen henkilön lähipiiriin kuuluvaksi katsotaan:</strong>"
       "<ul><li>Poliittisesti vaikutusvaltaisen henkilön puoliso tai puolisoon kansallisen "
       "lain mukaisesti rinnastettava kumppani</li>"
       "<li>Poliittisesti vaikutusvaltaisen henkilön lapset sekä heidän puolisonsa tai puolisoon "
       "kansallisen lain mukaisesti rinnastettava kumppani.</li>"
       "<li>Poliittisesti vaikutusvaltaisen henkilön vanhemmat</li></ul></p>")}}
    :questions
    (questions-registry/resolve-questions
     [[:kyc-person/PEP?]
      [:kyc-person/pep-edn {:data/template pep/schema}]])}

   :kyc.natural-person/identification
   {:ord 5.0
    :translations {:en "Identification"
                   :fi "Tunnistetiedot"}
    :info
    {:en ""
     :fi ""}
    :questions
    (questions-registry/resolve-questions
     [[:kyc-person/signer-email]
      [:kyc-person/type-of-identification-attachment]
      [:kyc-person/identification-expires]
      [:kyc-person/identification-attachment-not-certified]])}

   :kyc.natural-person/confirmation
   {:ord          6.0
    :translations {:en "Confirmation"
                   :fi "Tietojen vahvistaminen"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-person/confirmation-place]
                    [:kyc-person/confirmation-date]
                    [:kyc-person/confirmation-name]])}

   :kyc.natural-person/signature-info
   {:ord
    7.0
    :translations
    {:en ""
     :fi ""}

    :end-of-pdf?
    true

    :page-break-before?
    true

    :conditional-block
    (fn [_answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))

    :questions
    (questions-registry/resolve-questions
     [[:kyc-person/signature-confirmation
       {:data/type :data.type/info
        :optional-field? true
        :translations
        {:en
         (str "On behalf of the investor, I hereby confirm that the information I have "
              "declared in this form and in its appendices are true and correct. "
              "I undertake to inform Innovestor (backoffice@innovestor.fi) within 30 days in case of "
              "any changes to the declared information.")
         :fi
         (str "Vakuutan, että tässä lomakkeessa ja sen liitteissä olevat tiedot ovat oikeita, "
              "ja että sijoittaja sitoutuu ilmoittamaan näiden tietojen muutoksista "
              "Innovestorille (backoffice@innovestor.fi) 30 päivän kuluessa muutoksesta.")}}]])}


   :kyc.natural-person/signature
   {:ord
    8.0
    :translations
    {:en "Signatures"
     :fi "Allekirjoitukset"}

    :keep-together?
    true

    :end-of-pdf?
    true

    :conditional-block
    (fn [_answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))
    :section-not-read-only
    (fn [_answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))
    :questions
    (questions-registry/resolve-questions
     [[:kyc-legal-entity/signature-date
       {:conditional-field (fn [_answers kyc-process]
                             (some #{(:kyc-process/status kyc-process)}
                                   [:kyc-process.status/signatures
                                    :kyc-process.status/waiting-for-e-sign]))}]
      [:kyc-legal-entity/signature-name
       {:conditional-field (fn [_answers kyc-process]
                             (some #{(:kyc-process/status kyc-process)}
                                   [:kyc-process.status/signatures
                                    :kyc-process.status/waiting-for-e-sign]))}]
      [:kyc-legal-entity/signature-signature
       {:conditional-field (fn [_answers kyc-process]
                             (some #{(:kyc-process/status kyc-process)}
                                   [:kyc-process.status/signatures
                                    :kyc-process.status/waiting-for-e-sign]))}]])}})
